function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.readSt0{fill:#FFFFFF;}\n\t.readSt1{fill:#2DCB64;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 114,
  className: "readSt0",
  width: 367,
  height: 295
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "readSt1",
  d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256S114.6,0,256,0S512,114.6,512,256z M226.4,391.5l189.9-189.9 c6.4-6.4,6.4-16.9,0-23.4L393,154.9c-6.4-6.5-16.9-6.5-23.4,0L214.7,309.8l-72.3-72.3c-6.4-6.4-16.9-6.4-23.4,0l-23.4,23.4 c-6.4,6.4-6.4,16.9,0,23.4L203,391.5C209.5,398,219.9,398,226.4,391.5L226.4,391.5z"
});

function SvgReadActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadActive);
export default __webpack_public_path__ + "static/media/readActive.b47e11c8.svg";
export { ForwardRef as ReactComponent };